import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { IconButton, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PaginationProps {
  /** 0-based page index. */
  page: number;
  totalPages: number;
  onPageChange(page: number): void;
}

export function Pagination({
  page,
  totalPages,
  onPageChange,
}: PaginationProps) {
  const { t } = useTranslation(['translations']);
  const totalPageCount = totalPages > 0 ? totalPages : 1;
  return (
    <Root>
      <IconButton disabled={page === 0} onClick={() => onPageChange(page - 1)}>
        <ChevronLeftRounded />
      </IconButton>
      <Typography variant="body2">
        {t('common.paginatedTable.pageLabel', {
          defaultValue: 'Page {{page}} of {{totalPageCount}}',
          page: page + 1,
          totalPageCount,
        })}
      </Typography>
      <IconButton
        disabled={page === totalPageCount - 1}
        onClick={() => onPageChange(page + 1)}
      >
        <ChevronRightRounded />
      </IconButton>
    </Root>
  );
}

const Root = styled('div')(({ theme }) => ({
  flex: '0 0 auto',
  height: 54,
  borderTop: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 24,
  backgroundColor: theme.palette.background.default,
}));
